import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { NavLink, useLocation } from "react-router-dom";

import side_help_support_icon from "../../assets/images/icons/sidebar/sidebar_help_support_icon.png";

export default function SidebarModal(props) {
  const { isOpen, onClose, mode } = props;

  const location = useLocation();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1
      ? " bg-black "
      : "  hover:bg-gray-200 hover:cursor-pointer text-black ";
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <div className=" list-none  flex flex-col justify-between   primary-border-color ">
            <div className="text-white  pt-[1rem] ">
              {props.routes.map((prop, key) => {
                return (
                  <>
                    {!prop?.disable_sidebar && (
                      <li
                        className={
                          activeRoute(prop.path) +
                          " mb-1 h-12  pl-[2.2rem]   font-raleway   "
                        }
                        key={key}
                        onClick={onClose}
                      >
                        <NavLink
                          to={prop.layout + prop.path}
                          className="  flex flex-row gap-2 tracking-wider  items-center h-full mr-2   "
                        >
                          {prop.icon_element ? prop.icon_element : <></>}

                          <p>{prop.name}</p>
                        </NavLink>
                      </li>
                    )}
                  </>
                );
              })}
            </div>
            <div>
              {mode !== "admin" && (
                <li
                  className={
                    activeRoute("user/setting") +
                    " mb-1 h-12 flex flex-col pl-[2.3rem]  justify-center font-raleway   "
                  }
                  key={"Help and support"}
                >
                  <NavLink
                    to={"help_and_support"}
                    className="nav-NavLink  flex flex-row gap-2 nav-NavLink items-center h-full text-gray-600 "
                  >
                    <img src={side_help_support_icon} className="w-6 h-6" />

                    <p>{"Help & Support"}</p>
                  </NavLink>
                </li>
              )}
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
